import { NavLink, useNavigate } from "@solidjs/router";
import { Component } from "solid-js";
import SignInPage from "./users/sign-in";

const Home: Component = () => {
  // const navigate = useNavigate();
  // navigate("/users/sign-in");
  return (
    <>
      {/* <div class="container-fluid d-flex justify-content-center align-items-center">
        <div class="mt-5 p-4 ms-5 me-5 container-fluid primary-color-bg rounded-4 d-flex flex-column align-items-center">
          <h1 class="ms-2 mb-4 text-light">Home</h1>
          <nav class="d-flex justify-content-center align-items-center">
            <NavLink class="ms-2 me-2 mb-2 btn btn-primary p-2" href="/users/sign-in">
              sign-in
            </NavLink>
            <NavLink class="me-2 mb-2 btn btn-primary p-2" href="/users/sign-up">
              sign-up
            </NavLink>
          </nav>
        </div>
      </div> */}
      <SignInPage></SignInPage>
    </>
  );
};
export default Home;
